// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-instrument-dialog .mdc-dialog__surface{max-width:100% !important}`, "",{"version":3,"sources":["webpack://./src/elements/dialogs/edit-instrument-dialog/edit-instrument-dialog.scss"],"names":[],"mappings":"AAAA,6CAA6C,yBAAyB","sourcesContent":[".edit-instrument-dialog .mdc-dialog__surface{max-width:100% !important}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
